"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoFileInput = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UploadFileChooser = require("../UploadFileChooser");

require("./VideoFileInput.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var VideoFileInput = function VideoFileInput(props) {
  var videoRef = (0, _react.useRef)(null);
  var abortTimeout = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      url = _useState2[0],
      setUrl = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      file = _useState4[0],
      setFile = _useState4[1]; // unmount, prevent leak


  (0, _react.useEffect)(function () {
    return function () {
      clearTimeout(abortTimeout.current);
    };
  }, []); // load video on url change

  (0, _react.useEffect)(function () {
    if (url) {
      loadVideo(url);
    }
  }, [url]); // handle file input change

  var handleFile = function handleFile(e) {
    var f = e;
    var url = URL.createObjectURL(f);
    setFile(f);
    setUrl(url);
  }; // handle callback to parent


  var onCanPlay = function onCanPlay(result) {
    console.log("VideoFileInput onCanPlay", result);

    if (props.onCanPlay && typeof props.onCanPlay === "function") {
      console.log("VideoUpload onCanPlay", result, file, url);
      props.onCanPlay(result, file, url);
    }
  }; // try to load video to figure out if it can play


  var loadVideo = function loadVideo(url) {
    var video = videoRef.current;

    if (abortTimeout.current) {
      clearTimeout(abortTimeout.current);
      abortTimeout.current = null;
    }

    var onError = function onError(e) {
      console.log("VideoFileInput error", e);
      report(false, file, url);
    };

    var onVideoCanPlay = function onVideoCanPlay() {
      // if the video doesn't have height and width it cannot be played
      var cp = video.videoWidth > 0 && video.videoHeight > 0;
      console.log("VideoFileInput canplay", video.videoWidth, video.videoHeight, cp);
      report(cp, file, url);
    };

    var abort = function abort() {
      console.log("VideoFileInput abort");
      report(false, file, url);
    };

    var report = function report(ok) {
      if (abortTimeout.current) {
        clearTimeout(abortTimeout.current);
        abortTimeout.current = null;
      }

      video.removeEventListener("error", onError);
      video.removeEventListener("canplay", onVideoCanPlay);
      video.pause();
      video.src = null;
      onCanPlay(ok, file, url);
    };

    video.setAttribute("src", url);
    video.addEventListener("error", onError);
    video.addEventListener("canplay", onVideoCanPlay);
    video.load(); // 1500 seems to work well everywhere, lower is a problem on ios

    abortTimeout.current = setTimeout(abort, 1500);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "VideoFileInput"
  }, /*#__PURE__*/_react.default.createElement(_UploadFileChooser.UploadFileChooser, {
    name: "drop-file",
    onClose: function onClose(e) {
      console.log('File chooser closed');
    },
    onChoose: handleFile
  }), /*#__PURE__*/_react.default.createElement("video", {
    playsInline: true,
    ref: videoRef,
    autoPlay: true,
    muted: true,
    style: {
      width: "1px",
      height: "1px",
      opacity: "0"
    }
  })));
};

exports.VideoFileInput = VideoFileInput;